import { useQuery } from "@tanstack/react-query";
import { getOpportunities } from "@/helpers/apis";
import { GET_OPPORTUNITIES_DATA } from "../../constants";
import type { OpportunitiesFilters } from "../../schemas";

interface UseDiscoverOpportunitiesQueryProps {
  filterParams: OpportunitiesFilters;
  isInitialized: boolean;
  enabled?: boolean;
}

export const useDiscoverOpportunitiesQuery = ({
  filterParams,
  isInitialized,
  enabled = true,
}: UseDiscoverOpportunitiesQueryProps) => {
  return useQuery({
    queryKey: [GET_OPPORTUNITIES_DATA, filterParams],
    queryFn: () => getOpportunities(filterParams),
    enabled: isInitialized && enabled, // Only fetch when URL sync is complete and tab is active
  });
};
